import { render, staticRenderFns } from "./ICN001-04_battery_80.vue?vue&type=template&id=20c11870&"
import script from "./ICN001-04_battery_80.vue?vue&type=script&lang=js&"
export * from "./ICN001-04_battery_80.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports